import React from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

const stripePublicKey = import.meta.env.VITE_STRIPE_PUBLIC_KEY;




// Log environment for debugging (remove in production)
if (!stripePublicKey) {
  console.error("❌ CRITICAL: VITE_STRIPE_PUBLIC_KEY is not set! Payments will fail.");
  console.error("Please set VITE_STRIPE_PUBLIC_KEY in your .env or .env.production file");
} else if (stripePublicKey.includes("pk_test")) {
  console.warn("⚠️ WARNING: Using TEST Stripe keys. For production, use pk_live_* keys");
} else if (stripePublicKey.includes("pk_live")) {
  console.log("✓ Using PRODUCTION Stripe keys");
}

const stripePromise = loadStripe(stripePublicKey || "pk_test_default");

interface StripeProviderProps {
  children: React.ReactNode;
}

export const StripeProvider: React.FC<StripeProviderProps> = ({ children }) => {
  if (!stripePublicKey) {
    return (
      <div style={{
        padding: "20px",
        backgroundColor: "#fee",
        border: "2px solid red",
        borderRadius: "4px",
        color: "red",
        fontFamily: "monospace"
      }}>
        <strong> Stripe Configuration Error:</strong>
        <p>VITE_STRIPE_PUBLIC_KEY environment variable is not set.</p>
        <p>Please check your .env or .env.production file and ensure the Stripe public key is configured.</p>
      </div>
    );
  }

  return (
    <Elements stripe={stripePromise}>
      {children}
    </Elements>
  );
};

export default StripeProvider;
